import * as React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  checkBoxIcon: {
    fontSize: "22px",
    verticalAlign: "top",
  },
  mainText: {
    color: "#000000",
  },
  description: {
    color: "#000000",
    margin: "0px 0px 15px 22px",
  },
  text: {
    fontWeight: "bold",
    margin: "15px 0px"
  },
  textWithDescription: {
    fontWeight: "bold",
    marginTop: "15px",
  },
  underline: {
    textDecoration: "underline",
  }
}));

/** 宮交タクシーの予約ページでメールが届かない場合の確認事項。 */
const EmailCheckList: React.FC = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  /**
   * チェックボックスアイコン付きの見出し。
   * @param text チェックボックスアイコンの右側に表示する文言。
   * */
  const headline = (text: string) => {
    return (
      <Typography color="primary" className={classes.text}>
        <CheckBoxIcon color='inherit' className={classes.checkBoxIcon}/>
        { text }
      </Typography>
    );
  }

  /**
   * チェックボックスアイコン付きの見出し（詳細部分がついている場合）。
   * @param text チェックボックスアイコンの右側に表示する文言。
   * */
  const headlineWithDescription = (text: string) => {
    return (
      <Typography color="primary" className={classes.textWithDescription}>
        <CheckBoxIcon color='inherit' className={classes.checkBoxIcon}/>
        { text }
      </Typography>
    );
  }

  return (
    <div>
      <Typography className={classes.mainText}>
        {t('taxi:temporary_reservation_unreceived_string_1')}
      </Typography>
      { headline(t('taxi:wrong_mailaddress')) }
      { headline(t('taxi:in_trash')) }
      { headline(t('taxi:full_mailbox')) }

      { headlineWithDescription(t('taxi:security_soft_setting')) }
      <Typography className={classes.description}>
        {t('taxi:temporary_reservation_unreceived_string_2')}
      </Typography>

      { headlineWithDescription(t('taxi:provider_setting')) }
      <Typography className={classes.description}>
        {t('taxi:temporary_reservation_unreceived_string_3')}
        {t('taxi:temporary_reservation_unreceived_string_4')}
        {t('taxi:temporary_reservation_unreceived_string_5')}
      </Typography>

      { headlineWithDescription(t('taxi:reject_domain')) }
      { (i18n.language === 'en') &&
        <Typography className={classes.description}>
          For this service, emails are sent with (<span className={classes.underline}>{"@ana-maas-val.jp"}</span>).<br/>
          If this domain designation has been rejected, please deactivate the designation rejection.
        </Typography>
      }
      { (i18n.language !== 'en') &&
        <Typography className={classes.description}>
          本サービスでは（<span className={classes.underline}>{"@ana-maas-val.jp"}</span>）よりメールを送信いたします。<br/>
          ドメイン指定拒否がされている場合、指定拒否を解除いただくようお願いいたします。
        </Typography>
      }
    </div>
  );
}

export default EmailCheckList;
